export const RESTAURANT = {
  name: "Aradelá",
  fullName: "Aradelá Nigerian Restaurant",
  subtitle: "Nigerian Restaurant",
  address: "19 Stratford Road, Wolverton, Milton Keynes, MK12 5LJ",
  shortAddress: "Wolverton, Milton Keynes",
  phone: "01908 893098",
  phoneRaw: "01908893098",
  // International format for WhatsApp (UK)
  whatsapp: "441908893098",
  tagline: "Authentic Nigerian Flavours",
  taglineLong: "Bold Taste. Rich Culture. Unforgettable Experience.",
  hours: [
    { day: "Monday", time: "4:00pm – 11:00pm" },
    { day: "Tuesday – Saturday", time: "12:00pm – 11:00pm" },
    { day: "Sunday", time: "1:00pm – 7:00pm" },
  ],
  social: {
    instagram: "https://www.instagram.com/aradelarestaurant",
    instagramHandle: "@aradelarestaurant",
    facebook: "https://www.facebook.com/p/Aradel%C3%A1-Restaurant-61554169601682/",
    tiktok: "https://www.tiktok.com/@aradelarestaurant",
  },
  website: "https://www.aradelarestaurant.co.uk",
  email: "info@aradelarestaurant.co.uk",
  mapsEmbed:
    "https://www.google.com/maps?q=19+Stratford+Road,+Wolverton,+Milton+Keynes,+MK12+5LJ&output=embed",
  mapsLink:
    "https://www.google.com/maps/dir/?api=1&destination=19+Stratford+Road,+Wolverton,+Milton+Keynes,+MK12+5LJ",
};

export const MENU = [
  {
    category: "Appetisers",
    description: "Start the journey with bold, soul-warming bites.",
    items: [
      { name: "Puff Puff", price: 5.99, desc: "Golden Nigerian sweet dough, fluffy & nostalgic." },
      { name: "Akara", price: 5.99, desc: "Crispy black-eyed bean fritters with house pepper sauce." },
      { name: "Meat or Chicken Pie", price: 3.99, desc: "Flaky pastry stuffed with seasoned filling." },
      { name: "Banana Bread", price: 3.99, desc: "Warm, lightly spiced, melt-in-your-mouth." },
      { name: "Spicy Wings", price: 8.0, desc: "Marinated wings, smoky chilli glaze." },
      { name: "Spicy Goat Meat", price: 13.5, desc: "Slow-cooked goat tossed in fiery pepper blend." },
    ],
  },
  {
    category: "Brunch",
    description: "Late-morning indulgence, Nigerian style.",
    items: [
      { name: "Nigerian Breakfast", price: 12.99, desc: "A hearty plate to begin the day right." },
      { name: "Aboki Noodles & Egg", price: 13.0, desc: "Street-style noodles, peppered eggs." },
      { name: "Aboki Noodles with Suya", price: 15.5, desc: "Topped with our signature suya spice beef." },
    ],
  },
  {
    category: "Suya Specials",
    description: "Our flame-kissed signature — smoky, peppery, unforgettable.",
    items: [
      { name: "Chicken Suya", price: 11.5, desc: "Tender chicken in classic yaji spice." },
      { name: "Suya Wings", price: 10.99, desc: "Wings, char-grilled with house suya blend." },
      { name: "Suya Beef", price: 12.99, desc: "Thin-cut beef, smoky, peppery, addictive." },
      { name: "Suya Turkey Wings", price: 12.99, desc: "Juicy turkey wings, deep suya char." },
    ],
  },
  {
    category: "Traditional Mains",
    description: "Heritage recipes, plated with pride.",
    items: [
      { name: "Eko Shawarma", price: 14.5, desc: "A Lagos twist on the shawarma classic." },
      { name: "Gizdodo", price: 15.99, desc: "Plantain & gizzard stew, sweet meets spice." },
      { name: "Aradela Plantain & Wings", price: 14.5, desc: "Our house favourite, sweet & smoky." },
      { name: "Ayamashe", price: 18.0, desc: "Green pepper stew with assorted meat." },
      { name: "Jollof Rice", price: 15.99, desc: "Smoky party-style jollof, the gold standard." },
      { name: "Fried Rice", price: 15.99, desc: "Vibrant veggies, perfectly seasoned." },
      { name: "White Rice & Assorted Meat Stew", price: 15.5, desc: "Rich tomato stew, layered meats." },
      { name: "Native Jollof Rice", price: 17.99, desc: "Palm oil base, deep village flavours." },
      { name: "Beans & Dodo", price: 12.99, desc: "Creamy beans with sweet fried plantain." },
      { name: "Asaro", price: 16.99, desc: "Yam pottage with smoked fish & peppers." },
    ],
  },
  {
    category: "Mixed Grills",
    description: "Smoke, fire, and feast — built to share.",
    items: [
      { name: "Meal for One", price: 30.5, desc: "Grilled assortment with sides." },
      { name: "Meal for Two", price: 37.5, desc: "A generous spread for two." },
    ],
  },
  {
    category: "Sharing Platters",
    description: "Designed for the table, made for celebration.",
    items: [
      { name: "Meat Lover Platter", price: 36.99, desc: "Suya, peppered meats and grills." },
      { name: "Explorer Platter", price: 33.99, desc: "A tour of our most-loved bites." },
      { name: "Vegan Platter", price: 28.99, desc: "Plant-forward Nigerian flavours." },
    ],
  },
  {
    category: "Pepper Soup",
    description: "Aromatic, restorative, deeply spiced.",
    items: [
      { name: "Assorted Meat Pepper Soup", price: 14.99, desc: "Slow-simmered broth, layered meats." },
      { name: "Fish Pepper Soup", price: 16.99, desc: "Fresh fish in a fragrant chilli broth." },
    ],
  },
  {
    category: "Soups",
    description: "Pair with your favourite swallow.",
    items: [
      { name: "Eforiro", price: 19.5, desc: "Yoruba spinach stew with assorted meat." },
      { name: "Ewedu & Assorted Meat Stew", price: 20.5, desc: "Silky ewedu paired with rich stew." },
      { name: "Okro", price: 18.5, desc: "Velvety okra soup, full of texture." },
      { name: "Egusi", price: 19.5, desc: "Ground melon seed soup, deep & nutty." },
    ],
  },
  {
    category: "Sides",
    description: "The supporting cast — every one a star.",
    items: [
      { name: "Dodo", price: 5.99, desc: "Sweet fried plantain." },
      { name: "Fried Yam", price: 6.99, desc: "Golden crisp yam wedges." },
      { name: "Sweet Potato Fries", price: 5.5, desc: "Naturally sweet, lightly salted." },
      { name: "Moi Moi", price: 5.0, desc: "Steamed bean pudding." },
      { name: "Fries", price: 3.5, desc: "Classic, crispy, comforting." },
      { name: "Coleslaw", price: 2.99, desc: "Fresh, crunchy, creamy." },
    ],
  },
  {
    category: "Extras",
    description: "Build your perfect plate.",
    items: [
      { name: "Poundo Yam", price: 3.0 },
      { name: "Eba", price: 2.99 },
      { name: "Amala", price: 4.5 },
      { name: "Peppered Turkey", price: 6.0 },
      { name: "Peppered Chicken", price: 4.5 },
      { name: "Peppered Fish", price: 10.0 },
      { name: "Peppered Beef", price: 8.0 },
    ],
  },
  {
    category: "Smoothies",
    description: "Freshly blended, naturally vibrant.",
    items: [
      { name: "Very Berry", price: 5.99 },
      { name: "Banana Berry", price: 5.99 },
      { name: "Green Burst", price: 5.99 },
      { name: "Berry Blast", price: 5.99 },
      { name: "Tropical Blast", price: 5.99 },
    ],
  },
  {
    category: "Mocktails",
    description: "House-crafted, alcohol-free.",
    items: [
      { name: "Zobo Royale", price: 9.99, desc: "Hibiscus, citrus, ginger." },
      { name: "Chapman", price: 8.99, desc: "The Nigerian classic, perfectly balanced." },
    ],
  },
  {
    category: "Soft Drinks",
    items: [
      { name: "Malt", price: 3.99 },
      { name: "Zobo", price: 4.99 },
      { name: "Still Water", price: 2.5 },
      { name: "Sparkling Water", price: 2.5 },
      { name: "Nigerian Fanta", price: 4.0 },
      { name: "Coke / Diet Coke", price: 3.5 },
      { name: "Lemonade", price: 3.2 },
      { name: "Strawberry Lemonade", price: 4.99 },
      { name: "Red Bull", price: 3.6 },
      { name: "J2O", price: 4.99 },
    ],
  },
  {
    category: "Hot Drinks",
    items: [
      { name: "Green with Lemon Tea", price: 3.25 },
      { name: "Green Tea", price: 3.25 },
      { name: "Berry Tea", price: 3.5 },
      { name: "Ginger with Lemon Tea", price: 3.5 },
      { name: "Peppermint Tea", price: 3.85 },
      { name: "Ginger Tea", price: 3.5 },
    ],
  },
];

export const POPULAR_DISHES = [
  {
    name: "Smoky Jollof Rice",
    price: 15.99,
    desc: "Party-style party jollof with deep tomato base and char-kissed bottom-pot smoke.",
    image:
      "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/m2vb7rv2_image.jpeg",
    tag: "Signature",
  },
  {
    name: "Suya Beef",
    price: 12.99,
    desc: "Hand-cut beef rolled in yaji spice and flame-grilled to smoky perfection.",
    image:
      "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/pfotykea_IMG_8823.jpeg",
    tag: "Bestseller",
  },
  {
    name: "Aradela Plantain & Wings",
    price: 14.5,
    desc: "Our house favourite — sweet plantain meets bold, peppered wings.",
    image:
      "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/k06kmxgw_IMG_9998.jpeg",
    tag: "House Special",
  },
  {
    name: "Egusi Soup",
    price: 19.5,
    desc: "Ground melon seed soup, deep nutty richness, pair with your favourite swallow.",
    image:
      "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/ofa04sfi_IMG_8824.jpeg",
    tag: "Tradition",
  },
];

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/2c00x24z_IMG_8894.jpeg",
  jollof: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/zs0t7xg8_IMG_9100.jpeg",
  plantain: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/k06kmxgw_IMG_9998.jpeg",
  plating: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/2c00x24z_IMG_8894.jpeg",
  suya: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/pfotykea_IMG_8823.jpeg",
  wine: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/ng240rgv_image.jpeg",
  bar: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/d7z92nqe_IMG_8626.jpeg",
  noodles: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/p4iw4mae_image.jpeg",
  brunch: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/klgpzfsm_image.jpeg",
  egusi: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/ofa04sfi_IMG_8824.jpeg",
  // Existing
  wingsPlantain: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/k06kmxgw_IMG_9998.jpeg",
  pepperedWings: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/pkrghr6m_IMG_9997.jpeg",
  mealForTwo: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/ob1lv1fv_IMG_5451.jpeg",
  explorerPlatter: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/tc1xzmvz_IMG_9974.jpeg",
  mixedGrill: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/hde3w4lb_IMG_5450.jpeg",
  // New uploads
  shawarma: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/ic27z24l_IMG_9981.jpeg",
  asaro: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/iqfzcsll_IMG_4587.jpeg",
  pies: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/skx7nkdq_IMG_4422.jpeg",
  puffPuff: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/m38pwp5j_IMG_4411.jpeg",
  eforiro: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/nje047kz_IMG_4424.jpeg",
};

// Full gallery — drives gallery page tiles, instagram strip, etc.
// Each image used only ONCE
export const GALLERY_PHOTOS = [
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/2c00x24z_IMG_8894.jpeg", label: "Sharing Platter" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/hde3w4lb_IMG_5450.jpeg", label: "Mixed Grill" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/ob1lv1fv_IMG_5451.jpeg", label: "Meal for Two" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/zs0t7xg8_IMG_9100.jpeg", label: "Jollof Rice & Plantain" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/ic27z24l_IMG_9981.jpeg", label: "Eko Shawarma" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/tc1xzmvz_IMG_9974.jpeg", label: "Explorer Platter" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/k06kmxgw_IMG_9998.jpeg", label: "Wings, Yam & Plantain" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/iqfzcsll_IMG_4587.jpeg", label: "Asaro & Peppered Chicken" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/pkrghr6m_IMG_9997.jpeg", label: "Peppered Wings" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/m38pwp5j_IMG_4411.jpeg", label: "Puff Puff" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/pfotykea_IMG_8823.jpeg", label: "Peppered Goat" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/ofa04sfi_IMG_8824.jpeg", label: "Egusi Soup" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/nje047kz_IMG_4424.jpeg", label: "Eforiro" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/skx7nkdq_IMG_4422.jpeg", label: "Meat & Chicken Pies" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/klgpzfsm_image.jpeg", label: "Nigerian Breakfast" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/p4iw4mae_image.jpeg", label: "Aboki Noodles" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/ng240rgv_image.jpeg", label: "Berry Smoothies" },
  { src: "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/d7z92nqe_IMG_8626.jpeg", label: "The Bar" },
];
